import { createFileRoute } from '@tanstack/react-router';
import { AdminZoningPage } from '@/features/admin/admin-zoning-page';

export const Route = createFileRoute('/admin/zoning/')({
  component: AdminZoningIndexRoute,
});

function AdminZoningIndexRoute() {
  return <AdminZoningPage />;
}
